export default __webpack_public_path__ + "assets/images/1691726095693.jpg";